export default __webpack_public_path__ + "static/media/line-awesome.4b43b038.woff2";